import React, { useRef, useState } from 'react'
import classnames from 'classnames'
import inPercy from '@percy-io/in-percy'

import { IProps } from './index'
import { Image } from '../../elements/Image'
import { RichText } from '../../elements/RichText'
import { Text } from '../../elements/Text'
import { WistiaVideo } from '../../elements/WistiaVideo'
import effectLeft1 from '../../images/customers/effect-left-1.svg'
import effectRight1 from '../../images/customers/effect-right-1.svg'
import effectLeft2 from '../../images/customers/effect-left-2.svg'
import effectRight2 from '../../images/customers/effect-right-2.svg'
import effectLeft3 from '../../images/customers/effect-left-3.svg'
import effectRight3 from '../../images/customers/effect-right-3.svg'
import effectLeft4 from '../../images/customers/effect-left-4.svg'
import effectRight4 from '../../images/customers/effect-right-4.svg'
import playIcon from '../../images/play.svg'
import styles from './styles-legacy.scss'

import { CustomerStoryHero as CustomerStoryHeroDefault } from './component'
import { NewBrandingHoc } from '../../utils/NewBrandingHoc'

const effects = [
  {
    left: effectLeft1,
    right: effectRight1,
  },
  {
    left: effectLeft2,
    right: effectRight2,
  },
  {
    left: effectLeft3,
    right: effectRight3,
  },
  {
    left: effectLeft4,
    right: effectRight4,
  },
]

const getRandomEffect = () => {
  if (inPercy()) return 0
  return Math.floor(Math.random() * (effects.length - 1))
}

function CustomerStoryHeroLegacy({
  eyebrow,
  heading,
  subheading,
  image,
  video,
  hideIllustrations,
  wistiaId,
}: IProps) {
  const [isPlaying, setIsPlaying] = useState(false)
  const randomEffect = useRef(video ? 3 : getRandomEffect())
  const videoRef = useRef<HTMLVideoElement | null>(null)
  const effect = effects[randomEffect.current]

  function playVideo() {
    setIsPlaying(true)
    videoRef.current?.play()
  }

  const heroClassNames = classnames('customer-story-hero', {
    'customer-story-hero--video': !!video,
  })

  const assetClassNames = classnames(
    'customer-story-hero__asset',
    `customer-story-hero__asset--variant-${randomEffect.current}`,
    {
      'customer-story-hero__asset--hide-illustrations': hideIllustrations,
    },
  )

  return (
    <div className={heroClassNames}>
      <div className="customer-story-hero__wrapper">
        <div className="customer-story-hero__content">
          {eyebrow && (
            <div className="customer-story-hero__eyebrow">
              <Text size="lg-eyebrow">{eyebrow}</Text>
            </div>
          )}
          <h1 className="customer-story-hero__heading">
            <Text size="heading">{heading}</Text>
          </h1>
          {subheading && !video && (
            <div className="customer-story-hero__subheading">
              <RichText document={subheading} />
            </div>
          )}
        </div>
        <div className="customer-story-hero__asset-container">
          <div className={assetClassNames}>
            {/* eslint-disable-next-line */}
            <img className="customer-story-hero__effect--left" src={effect.left} />
            {wistiaId ? (
              <WistiaVideo wistiaId={wistiaId} title={eyebrow ? eyebrow : ''} />
            ) : video ? (
              // eslint-disable-next-line
              <video ref={videoRef} src={video} poster={image.url} controls={isPlaying} />
            ) : (
              <Image {...image} borderRadius={25} />
            )}
            {video && !isPlaying && (
              // eslint-disable-next-line
              <img
                src={playIcon}
                className="customer-story-hero__play-icon"
                onClick={playVideo}
                aria-label="Play video"
                // eslint-disable-next-line
                tabIndex={0}
              />
            )}
            {/* eslint-disable-next-line */}
            <img className="customer-story-hero__effect--right" src={effect.right} />
          </div>
        </div>
        {subheading && video && (
          <div className="customer-story-hero__subheading">
            <RichText document={subheading} />
          </div>
        )}
      </div>
      <style jsx>{styles}</style>
    </div>
  )
}

export const CustomerStoryHero = NewBrandingHoc(CustomerStoryHeroLegacy, CustomerStoryHeroDefault)
